import React, { useState, useMemo, ReactNode } from 'react';
import { PracticeContext } from './usePracticeContext';

export interface Practice {
  id: string;
  name: string;
  slug: string;
  status: string;
  settings?: Record<string, unknown>;
}

export function PracticeProvider({ children }: { children: ReactNode }) {
  const [practice, setPractice] = useState<Practice | null>(null);

  const value = useMemo(() => ({ practice, setPractice }), [practice]);

  return <PracticeContext.Provider value={value}>{children}</PracticeContext.Provider>;
}
